import { useEffect, useState } from "react";
import ComponentCard from "../../../components/common/ComponentCard";
import Button from "../../../components/ui/button/Button";
import Label from "../../../components/form/Label";
import Input from "../../../components/form/input/InputField";
import Form from "../../../components/form/Form";
import Select from "../../../components/form/Select";
import { useNavigate } from "react-router";
import Switch from "../../../components/form/switch/Switch";

export default function AddInspectionType() {
  const apiUrl = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("token");

  const [formData, setFormData] = useState({
    inspectiontypename: "",
    status: "",
    autoRenewal: false,
    renewPeriod: "",
  });

  const [errors, setErrors] = useState({
    inspectiontypename: "",
    status: "",
  });

  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    // console.log("Form submitted", formData);

    //Form validation
    let newErrors: any = {};
    if (!formData.inspectiontypename) newErrors.inspectiontypename = "Inspection Type Name is required";
    if (!formData.status) newErrors.status = "Status is required";

    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) return;

    try{
      let renewPeriodValue = null;
      if (formData.autoRenewal) {
        switch (formData.renewPeriod) {
          case "Week": renewPeriodValue = 1; break;
          case "2 Weeks": renewPeriodValue = 2; break;
          case "Month": renewPeriodValue = 3; break;
          
          case "3 Months": renewPeriodValue = 4; break;
          case "6 Months": renewPeriodValue = 5; break;
          case "Year": renewPeriodValue = 6; break;
          default: renewPeriodValue = 0;
        }
      }

      const payload = {
        inspectiontypename: formData.inspectiontypename,
        status: formData.status,
        autoRenewal: formData.autoRenewal,
        renewPeriod: renewPeriodValue,
      };

      const response = await fetch(`${apiUrl}/inspection_types`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          token: token || "",
        },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        navigate("/inspection-types");
      }

    }catch(error){
      console.error("Error submitting form:", error);
    }
  };

  const handleCancel = () => {
    navigate("/inspection-types");
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    setErrors({
      ...errors,
      [e.target.name]: "",
    });
  };

  const handleSelectStatus = (option: any) => {
    setFormData({
      ...formData,
      status: option,
    });
    setErrors({
      ...errors,
      status: "",
    });
  };

  //Handle Auto Renewal switch
  const handleAutoRenewalChange = (checked: boolean) => {
    setFormData({
      ...formData,
      autoRenewal: checked,
      renewPeriod: checked ? formData.renewPeriod : "",
    });
  };

  //Handle Renew Period selection
  const handleRenewPeriodSelect = (option: any) => {
    setFormData({
      ...formData,
      renewPeriod: option,
    });
  };

  return (
    <>
      <ComponentCard title="Add New Inspection Type">
        <Form onSubmit={handleSubmit}>
          <div className="grid gap-6">
            <div className="col-span-full">
              <h4 className="pb-4 text-base font-medium text-gray-800 border-b border-gray-200 dark:border-gray-800 dark:text-white/90">
                Inspection Type Details
              </h4>
            </div>

            {/* Inspection Type Name */}
            <div>
              <Label>Inspection Type</Label>
              <Input
                type="text"
                id="inspectiontypename"
                name="inspectiontypename"
                value={formData.inspectiontypename}
                onChange={handleChange}
              />
              {errors.inspectiontypename && (
                <p className="text-red-500 text-sm">{errors.inspectiontypename}</p>
              )}
            </div>

            {/* Status */}
            <div>
              <Label>Status</Label>
              <Select
                options={[
                  { value: "Current", label: "Current" },
                  { value: "Non-Current", label: "Non-Current" },
                ]}
                onChange={handleSelectStatus}
                className="mt-2 bg-gray-50 dark:bg-gray-800"
              />
              {errors.status && (
                <p className="text-red-500 text-sm">{errors.status}</p>
              )}
            </div>

            {/* Auto Renewal Switch */}
            <div className="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm dark:border-gray-800 dark:bg-gray-900">
              <div className="flex gap-4 items-center">
                <Switch
                  label="Auto Renewal"
                  defaultChecked={formData.autoRenewal}
                  onChange={(checked: boolean) => handleAutoRenewalChange(checked)}
                />
              </div>
            </div>

            {/* Conditionally Render Renew Period */}
            {formData.autoRenewal && (
              <div>
                <Label>Renew Period</Label>
                <Select
                  options={[
                    { value: "Week", label: "Week" },
                    { value: "2 Weeks", label: "2 Weeks" },
                    { value: "Month", label: "Month" },
                    { value: "3 Months", label: "3 Months" },
                    { value: "6 Months", label: "6 Months" },
                    { value: "Year", label: "Year" },
                  ]}
                  onChange={handleRenewPeriodSelect}
                  className="mt-2 bg-gray-50 dark:bg-gray-800"
                />
              </div>
            )}

            {/* Buttons */}
            <div className="flex gap-3">
              <Button size="sm" type="submit">Save Changes</Button>
              <Button size="sm" variant="outline" type="button" onClick={handleCancel}>
                Cancel
              </Button>
            </div>
          </div>
        </Form>
      </ComponentCard>
    </>
  );
}
